import { useState } from 'react';
import './App.css';

// ตัวอย่าง categories: สัตว์, สิ่งของ, อาหาร, อาชีพ, สถานที่, ร่างกาย, ธรรมชาติ ฯลฯ
const answers = [
  { word: "แมว", category: "สัตว์" },
  { word: "หมา", category: "สัตว์" },
  { word: "ปลา", category: "สัตว์" },
  { word: "นก", category: "สัตว์" },
  { word: "ต้นไม้", category: "ธรรมชาติ" },
  { word: "ดอกไม้", category: "ธรรมชาติ" },
  { word: "บ้าน", category: "สิ่งของ" },
  { word: "รถ", category: "สิ่งของ" },
  { word: "โต๊ะ", category: "สิ่งของ" },
  { word: "เก้าอี้", category: "สิ่งของ" },
  { word: "น้ำ", category: "ธรรมชาติ" },
  { word: "ไฟ", category: "ธรรมชาติ" },
  { word: "ลม", category: "ธรรมชาติ" },
  { word: "ฝน", category: "ธรรมชาติ" },
  { word: "แดด", category: "ธรรมชาติ" },
  { word: "คน", category: "ร่างกาย" },
  { word: "เด็ก", category: "ร่างกาย" },
  { word: "ครู", category: "อาชีพ" },
  { word: "นักเรียน", category: "อาชีพ" },
  { word: "หนังสือ", category: "สิ่งของ" },
  { word: "ปากกา", category: "สิ่งของ" },
  { word: "ดินสอ", category: "สิ่งของ" },
  { word: "กระเป๋า", category: "สิ่งของ" },
  { word: "โทรศัพท์", category: "สิ่งของ" },
  { word: "นาฬิกา", category: "สิ่งของ" },
  { word: "รองเท้า", category: "สิ่งของ" },
  { word: "เสื้อ", category: "สิ่งของ" },
  { word: "กางเกง", category: "สิ่งของ" },
  { word: "หมวก", category: "สิ่งของ" },
  { word: "ถุงเท้า", category: "สิ่งของ" },
  { word: "ข้าว", category: "อาหาร" },
  { word: "น้ำผลไม้", category: "อาหาร" },
  { word: "น้ำเปล่า", category: "อาหาร" },
  { word: "ขนม", category: "อาหาร" },
  { word: "ผลไม้", category: "อาหาร" },
  { word: "ส้ม", category: "อาหาร" },
  { word: "กล้วย", category: "อาหาร" },
  { word: "มะม่วง", category: "อาหาร" },
  { word: "แตงโม", category: "อาหาร" },
  { word: "แอปเปิ้ล", category: "อาหาร" },
  { word: "รถไฟ", category: "สิ่งของ" },
  { word: "เครื่องบิน", category: "สิ่งของ" },
  { word: "เรือ", category: "สิ่งของ" },
  { word: "จักรยาน", category: "สิ่งของ" },
  { word: "รถยนต์", category: "สิ่งของ" },
  { word: "ถนน", category: "สิ่งของ" },
  { word: "สะพาน", category: "สิ่งของ" },
  { word: "ตึก", category: "สิ่งของ" },
  { word: "สนาม", category: "สถานที่" },
  { word: "สวน", category: "สถานที่" },
  { word: "หัวใจ", category: "ร่างกาย" },
  { word: "สมอง", category: "ร่างกาย" },
  { word: "มือ", category: "ร่างกาย" },
  { word: "เท้า", category: "ร่างกาย" },
  { word: "ตา", category: "ร่างกาย" },
  { word: "หู", category: "ร่างกาย" },
  { word: "จมูก", category: "ร่างกาย" },
  { word: "ปาก", category: "ร่างกาย" },
  { word: "ฟัน", category: "ร่างกาย" },
  { word: "ผม", category: "ร่างกาย" },
  { word: "หมอ", category: "อาชีพ" },
  { word: "พยาบาล", category: "อาชีพ" },
  { word: "ตำรวจ", category: "อาชีพ" },
  { word: "นักบิน", category: "อาชีพ" },
  { word: "นักร้อง", category: "อาชีพ" },
  { word: "นักกีฬา", category: "อาชีพ" },
  { word: "ศิลปิน", category: "อาชีพ" },
  { word: "ชาวนา", category: "อาชีพ" },
  { word: "ชาวประมง", category: "อาชีพ" },
  { word: "คนขายของ", category: "อาชีพ" }
];

// ฟังก์ชันสุ่มคะแนนหลอก (คะแนนเต็ม 10,000)
function getFakeScore(guess, answerWord, answerCategory) {
  if (guess === answerWord) return 10000;
  // หา category ของคำที่ทาย
  const guessObj = answers.find(a => a.word === guess);
  if (guessObj && guessObj.category === answerCategory) {
    // หมวดหมู่เดียวกัน
    return Math.floor(Math.random() * 2000) + 7000; // 7000-9000
  }
  // คนละหมวดหมู่
  return Math.floor(Math.random() * 2900) + 100; // 100-3000
}

function App() {
  // สุ่มคำเฉลยรอบแรก
  const [answer, setAnswer] = useState(answers[Math.floor(Math.random() * answers.length)].word);
  const [guess, setGuess] = useState(''); // เก็บข้อความที่ผู้เล่นพิมพ์
  const [history, setHistory] = useState([]); // เก็บประวัติการทาย
  const [isCorrect, setIsCorrect] = useState(false); // เช็คว่าทายถูกหรือยัง
  const [lastAnswer, setLastAnswer] = useState(null); // เก็บคำเฉลยรอบที่แล้ว
  const [scores, setScores] = useState([]); // เก็บคะแนนแต่ละคำ
  const [showHint, setShowHint] = useState(false); // เพิ่ม state สำหรับคำใบ้
  const [showVocab, setShowVocab] = useState(false); // state สำหรับแสดง/ซ่อนคลังคำศัพท์

  // ฟังก์ชันเมื่อกดปุ่ม "ทาย" หรือกด Enter
  const handleSubmit = () => {
    if (guess.trim() === '') return; // ถ้าไม่ได้พิมพ์อะไร ไม่ต้องทำอะไร
    const score = getFakeScore(guess.trim(), answer, answers.find(a => a.word === answer).category);
    setHistory([...history, guess]); // เพิ่มคำที่ทายเข้าไปในประวัติ
    setScores([...scores, score]);
    if (guess.trim() === answer) {
      setIsCorrect(true); // ถ้าทายถูก ให้เปลี่ยนสถานะเป็นถูกต้อง
      setLastAnswer(null); // ซ่อนคำเฉลยรอบที่แล้วเมื่อทายถูกในรอบใหม่
    }
    setGuess(''); // ล้างกล่องข้อความหลังทาย
  };

  // ฟังก์ชันเมื่อกดปุ่ม "เริ่มใหม่"
  const handleRestart = () => {
    if (isCorrect) {
      setLastAnswer(answer); // เก็บคำเฉลยรอบที่แล้วถ้ารอบที่แล้วทายถูก
    }
    setGuess('');
    setHistory([]);
    setScores([]);
    setIsCorrect(false);
    // สุ่มคำเฉลยใหม่ทุกครั้งที่เริ่มใหม่
    setAnswer(answers[Math.floor(Math.random() * answers.length)].word);
  };

  // ฟังก์ชันเมื่อกดปุ่ม "เฉลยคำตอบ"
  const handleReveal = () => {
    setIsCorrect(true); // จบเกม
    setLastAnswer(null); // ไม่ต้องโชว์เฉลยรอบที่แล้ว
  };

  // หา category ของคำเฉลยปัจจุบัน

  return (
    <div
      className="App"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0a2342 0%, #1e3a5c 100%)",
        color: "#fff",
        fontFamily: "Prompt, sans-serif",
        textShadow: "2px 2px 4px #000, 0 0 2px #fff"
      }}
    >
      <h1
        style={{
          color: "#fff", // เปลี่ยนเป็นสีขาว
          textShadow: "2px 2px 8px #000"
        }}
      >
        เกมทายคำ (Contexto ภาษาไทย)
      </h1>

      {/* กลุ่มกล่องพิมพ์และปุ่มทาย */}
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: 16,
        marginBottom: 24,
        justifyContent: "center"
      }}>
        {/* กล่องให้พิมพ์คำ */}
        <input
          type="text"
          placeholder="พิมพ์คำภาษาไทยที่นี่"
          value={guess}
          onChange={e => {
            const value = e.target.value;
            // ตรวจสอบว่ามีตัวอักษรที่ไม่ใช่ภาษาไทยหรือไม่
            if (/[^ก-๙\s]+/i.test(value)) {
              alert("โปรดพิมภาษาไทย");
              return;
            }
            setGuess(value);
          }}
          disabled={isCorrect}
          style={{
            color: "#00eaff",
            background: "#112244",
            border: "1.5px solid #00eaff",
            borderRadius: "6px 0 0 6px",
            padding: 8,
            fontSize: 18,
            fontFamily: "Prompt, sans-serif",
            outline: "none",
            marginBottom: 0,
            width: 300
          }}
          onKeyDown={e => {
            if (e.key === 'Enter' && !isCorrect) {
              handleSubmit();
            }
          }}
        />
        {/* ปุ่มทาย */}
        <button onClick={handleSubmit} disabled={isCorrect}
          style={{
            background: "#00bcd4",
            color: "#fff",
            border: "none",
            borderRadius: "0 6px 6px 0",
            padding: "8px 18px",
            fontWeight: "bold",
            marginRight: 0,
            boxShadow: "0 2px 8px #0004"
          }}
        >ทาย</button>
        {/* ปุ่มเฉลยคำตอบ */}
        <button onClick={handleReveal} disabled={isCorrect}
          style={{
            background: "#e53935",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            padding: "8px 18px",
            fontWeight: "bold",
            marginRight: 0,
            boxShadow: "0 2px 8px #0004"
          }}
        >เฉลยคำตอบ</button>
        {/* ปุ่มคำใบ้ */}
        <button onClick={() => setShowHint(true)} disabled={isCorrect || showHint}
          style={{
            background: "#1976d2",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            padding: "8px 18px",
            fontWeight: "bold",
            marginRight: 0,
            boxShadow: "0 2px 8px #0004"
          }}
        >คำใบ้</button>
      </div>

      {/* ปุ่มคลังคำศัพท์ */}
      <div style={{ textAlign: "center", marginBottom: 16 }}>
        <button
          onClick={() => setShowVocab(!showVocab)}
          style={{
            background: "#ffb300",
            color: "#222",
            border: "none",
            borderRadius: 8,
            padding: "10px 28px",
            fontWeight: "bold",
            fontSize: 20,
            boxShadow: "0 2px 8px #0002",
            cursor: "pointer"
          }}
        >
          คลังคำศัพท์
        </button>
      </div>

      {/* แสดงคลังคำศัพท์ */}
      {showVocab && (
        <div
          style={{
            background: "#fff",
            color: "#222",
            borderRadius: 12,
            maxWidth: 500,
            margin: "0 auto 32px auto",
            padding: 24,
            boxShadow: "0 4px 24px #0003",
            maxHeight: 400,
            overflowY: "auto"
          }}
        >
          <h2 style={{ marginTop: 0, color: "#1976d2", textShadow: "none" }}>คลังคำศัพท์ทั้งหมด</h2>
          <ul style={{ columns: 2, fontSize: 18, paddingLeft: 24, textShadow: "none" }}>
            {answers.map((a, i) => (
              <li key={a.word + i} style={{ marginBottom: 6, textShadow: "none" }}>
                <b style={{ textShadow: "none" }}>{a.word}</b> <span style={{ color: "#888", fontSize: 14, textShadow: "none" }}>({a.category})</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* กลุ่มปุ่มเริ่มใหม่และลบประวัติ */}
      <div style={{ marginBottom: 24 }}>
        {/* ปุ่มเริ่มใหม่ */}
        <button onClick={handleRestart}
          style={{
            background: "#fff",
            color: "#222",
            border: "none",
            borderRadius: 6,
            padding: "8px 18px",
            fontWeight: "bold",
            marginRight: 8,
            boxShadow: "0 2px 8px #0002"
          }}
        >เริ่มใหม่</button>
        {/* ปุ่มลบประวัติ */}
        <button onClick={() => { setHistory([]); setScores([]); }}
          style={{
            background: "#fff",
            color: "#222",
            border: "none",
            borderRadius: 6,
            padding: "8px 18px",
            fontWeight: "bold",
            boxShadow: "0 2px 8px #0002"
          }}
        >ลบประวัติการทาย</button>
      </div>

      {/* ข้อมูลสรุป */}
      <p style={{color: "#00eaff", fontWeight: "bold"}}>จำนวนครั้งที่ทาย: {history.length}</p>
      {/* แสดงคำเฉลยรอบที่แล้วถ้ามี */}
      {lastAnswer && (
        <p style={{color: "#b388ff", fontWeight: "bold"}}>คำเฉลยรอบที่แล้วคือ: {lastAnswer}</p>
      )}
      {/* แสดงข้อความเมื่อทายถูก */}
      {isCorrect && (
        <>
          <p style={{color: "green"}}>คุณทายถูกต้อง!</p>
          <p style={{color: "purple"}}>คุณใช้ {history.length} ครั้งในการทายถูก</p>
          <p style={{color: "#00ffae", fontWeight: "bold"}}>คำเฉลยคือ: {answer}</p>
        </>
      )}

      {/* แสดงประวัติการทาย (ล่าสุดอยู่บนสุด) พร้อมคะแนนและหลอดคะแนน */}
      <ul>
        {[...history].map((item, idx) => {
          const score = scores[idx];
          const guessObj = answers.find(a => a.word === item);
          return (
            <li key={history.length - idx - 1} style={{marginBottom: 10}}>
              <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
                <span>
                  คุณทายว่า: <b>{item}</b>
                  {guessObj && (
                    <span style={{fontSize: 13, color: "#888", marginLeft: 6}}>
                      ({guessObj.category})
                    </span>
                  )}
                </span>
                <div style={{
                  background: '#eee',
                  borderRadius: 8,
                  width: 120,
                  height: 18,
                  overflow: 'hidden',
                  border: '1px solid #ccc'
                }}>
                  <div style={{
                    background: score === 10000 ? '#4caf50' : '#ff9800',
                    width: `${Math.round((score/10000)*100)}%`,
                    height: '100%',
                    transition: 'width 0.3s'
                  }} />
                </div>
                <span style={{
                  color: score === 10000 ? '#4caf50' : '#ff9800',
                  fontWeight: 'bold',
                  minWidth: 50,
                  textAlign: 'right'
                }}>{score}</span>
              </div>
            </li>
          );
        }).reverse()}
      </ul>
    {/* ปุ่ม support me ที่ขวาล่าง */}
    <div
      style={{
        position: "fixed",
        right: "2vw",
        bottom: "2vw",
        zIndex: 1000
      }}
    >
      <button
        onClick={() =>
          alert(
            "สนับสนุนเพื่อเป็นกำลังใจให้ผมได้ที่\nบัญชีไทยพาณิชย์/SCB : 4058454859\nขอบพระคุณมากครับ"
          )
        }
        style={{
          background: "#ff4081",
          color: "#fff",
          border: "none",
          borderRadius: "1vw",
          padding: "1vw 2vw",
          fontWeight: "bold",
          fontSize: "1.2vw",
          boxShadow: "0 2px 8px #0004",
          cursor: "pointer"
        }}
      >
        support me
      </button>
    </div>
    </div>
  );
}

export default App;
